document.addEventListener('DOMContentLoaded', function () {
    // ==========================================
    // Mobile Navigation
    // ==========================================
    const mobileNavToggle = document.querySelector('.js-mobile-nav-toggle');
    const mobileNavClose = document.querySelector('.js-mobile-nav-close');
    const mobileNav = document.getElementById('MobileNav');
    const mobileNavOverlay = document.getElementById('MobileNavOverlay');


    function openMobileNav() {
        document.body.classList.add('mobile-nav-open');
        if (mobileNav) mobileNav.classList.add('is-active');
        if (mobileNavOverlay) mobileNavOverlay.classList.add('is-active');
    }

    function closeMobileNav() {
        document.body.classList.remove('mobile-nav-open');
        if (mobileNav) mobileNav.classList.remove('is-active');
        if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-active');
    }

    function toggleMobileNav() {
        if (mobileNav && mobileNav.classList.contains('is-active')) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    }

    if (mobileNavToggle) {
        mobileNavToggle.addEventListener('click', function (e) {
            e.preventDefault();
            toggleMobileNav();
        });
    }

    if (mobileNavClose) {
        mobileNavClose.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileNav();
        });
    }

    if (mobileNavOverlay) {
        mobileNavOverlay.addEventListener('click', function () {
            closeMobileNav();
        });
    }

    // Mobile Submenus
    const submenuToggles = document.querySelectorAll('.js-mobile-submenu-toggle');
    submenuToggles.forEach(toggle => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            this.classList.toggle('is-active');
            const submenu = this.nextElementSibling;
            if (submenu) {
                submenu.classList.toggle('is-open');
            }
        });
    });

    // ==========================================
    // Search Popup
    // ==========================================
    const searchToggles = document.querySelectorAll('.js-search-toggle');
    const searchPopup = document.getElementById('SearchPopup');
    const searchClose = document.querySelectorAll('.js-search-close');

    function toggleSearch() {
        if (searchPopup) {
            searchPopup.classList.toggle('is-active');
            if (searchPopup.classList.contains('is-active')) {
                setTimeout(() => {
                    const input = searchPopup.querySelector('input[type="search"]');
                    if (input) input.focus();
                }, 100);
            }
        }
    }

    searchToggles.forEach(toggle => {
        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            toggleSearch();
        });
    });

    searchClose.forEach(close => {
        close.addEventListener('click', function (e) {
            e.preventDefault();
            toggleSearch();
        });
    });

    // ==========================================
    // Account Dropdown
    // ==========================================
    const accountBtn = document.getElementById('accountIconBtn');
    const accountDropdown = document.getElementById('accountDropdown');

    if (accountBtn && accountDropdown) {
        // Toggle Dropdown
        accountBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            accountDropdown.classList.toggle('is-active');
        });

        // Close on click outside
        document.addEventListener('click', function (e) {
            if (!accountBtn.contains(e.target) && !accountDropdown.contains(e.target)) {
                accountDropdown.classList.remove('is-active');
            }
        });

        // Close on Escape
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                accountDropdown.classList.remove('is-active');
            }
        });

        // Auth State Management
        const userInfo = document.getElementById('accountUserInfo');
        const userEmail = document.getElementById('userEmail');
        const retailLink = document.getElementById('retailAccountLink');
        const wholesaleLink = document.getElementById('wholesaleAccountLink');
        const loginLink = document.getElementById('loginLink');
        const signupLink = document.getElementById('signupWholesaleLink');
        const signOutBtn = document.getElementById('signOutBtn');

        function updateAccountUI(session) {
            if (session) {
                // User is Logged In
                accountBtn.classList.add('is-authenticated');

                if (userInfo) {
                    userInfo.style.display = 'block';
                    if (userEmail) userEmail.textContent = session.user.email;
                }

                if (retailLink) {
                    retailLink.style.display = 'flex';
                    const retailLogout = document.getElementById('retailLogoutLink');

                    // Update text if not logged into Retail (Shopify)
                    const retailTitle = retailLink.querySelector('.account-dropdown__title');

                    if (window.isShopifyCustomer) {
                        if (retailTitle) retailTitle.textContent = "My Retail Orders";
                        if (retailLogout) retailLogout.style.display = 'flex';
                    } else {
                        if (retailTitle) retailTitle.textContent = "Login to Retail";
                        if (retailLogout) retailLogout.style.display = 'none';
                    }
                }
                if (wholesaleLink) wholesaleLink.style.display = 'flex';
                if (signOutBtn) signOutBtn.style.display = 'flex';

                if (loginLink) loginLink.style.display = 'none';
                if (signupLink) signupLink.style.display = 'none';
            } else {
                // User is Logged Out
                accountBtn.classList.remove('is-authenticated');

                if (userInfo) userInfo.style.display = 'none';
                if (retailLink) retailLink.style.display = 'none';
                if (wholesaleLink) wholesaleLink.style.display = 'none';
                if (signOutBtn) signOutBtn.style.display = 'none';

                if (loginLink) loginLink.style.display = 'flex';
                if (signupLink) signupLink.style.display = 'flex';
            }
        }

        // Initialize Supabase Client and Check Session
        if (window.supabaseClient) {
            window.supabaseClient.getClient().then(client => {
                // Check initial session
                client.auth.getSession().then(({ data: { session } }) => {
                    updateAccountUI(session);
                });

                // Listen for auth changes
                client.auth.onAuthStateChange((event, session) => {
                    updateAccountUI(session);
                    if (event === 'SIGNED_OUT') {
                        window.location.reload(); // Refresh to clear any other state
                    }
                });
            });
        }

        // Handle Sign Out
        if (signOutBtn) {
            signOutBtn.addEventListener('click', async function (e) {
                e.preventDefault();
                if (window.supabaseClient) {
                    await window.supabaseClient.signOut();
                    accountDropdown.classList.remove('is-active');
                }
            });
        }
    }

    // ==========================================
    // Footer Accordion (Mobile)
    // ==========================================
    const footerHeadings = document.querySelectorAll('.footer__heading');

    footerHeadings.forEach(heading => {
        heading.addEventListener('click', function () {
            if (window.innerWidth >= 750) return; // Disable on desktop/tablet

            const column = this.closest('.footer__column');
            const isAlreadyOpen = column.classList.contains('is-open');

            // Close all other instances if you want accordion style (one open at a time)
            // document.querySelectorAll('.footer__column.is-open').forEach(col => col.classList.remove('is-open'));

            // Toggle current
            if (!isAlreadyOpen) {
                column.classList.add('is-open');
            } else {
                column.classList.remove('is-open');
            }
        });
    });
});
